/** Sometimes you need to know how many items are there in field array component. */
export var getFieldArrayLength = function (values) { var _a; return values[(_a = Object.keys(values)[0]) === null || _a === void 0 ? void 0 : _a.length]; };
